/**
 * Определяет видимость плавающих действий приложения по маршруту и сессии.
 * Используется в App.vue; не управляет содержимым самих действий.
 */

/** Сохраняет помощь на экране без компании и в профиле без общего layout. */
export function shouldShowFloatingActions({
  showLayout,
  isAuthenticated,
  hasCompany,
  routeName,
  isContentFullscreen,
}) {
  if (isContentFullscreen) return false;

  return showLayout || (
    isAuthenticated &&
    !hasCompany &&
    ["NoCompanies", "UserProfile"].includes(routeName)
  );
}
